import React from "react"

const NotFound = () => {
  return (
    <div>
      <div style={{ color: "white", margin: "230px", fontSize: "70px" }}>
        Page Not Found
      </div>
    </div>
  )
}

export default NotFound
